module.exports = __webpack_public_path__ + "img/hearts-start-overlay.0e730185.svg";